import { Injectable } from '@angular/core';
import { UserService } from '@app/core/services/user.service';
import { UserDataService } from '@app/core/services/user-data.service';
import { GridDisplaySettings } from '@app/models';
import { InitDossiersInLocalStorage, SearchDossiersSuccess } from '@app/pcs/actions/dossier-search';
import { UpdateUserFilterFail, UpdateUserFilterSuccess } from '@app/pcs/actions/user-filter';
import { DossierSearchType, UserFilter } from '@app/pcs/models';
import { UserFilterDataService } from '@app/pcs/services/user-filter-data.service';
import { updateGridDisplaySettings, updateGridDisplaySettingsForColumns } from '@app/pcs/util';
import { fromJson, toJsonString } from '@util';
import { DataGridColumnWithId } from 'ngrx-data-grid';
import * as R from 'ramda';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable()
export class FilterDisplaySettingsService {

  updateForColumns(columns: DataGridColumnWithId[], selectedFilter: UserFilter) {
    const updatedDisplaySettings = updateGridDisplaySettingsForColumns(
      columns, fromJson(selectedFilter.displaySettings)
    );
    return this.saveUserFilter(selectedFilter, updatedDisplaySettings);
  }

  updateForColumn(updatedColumn: DataGridColumnWithId, selectedFilter: UserFilter) {
    const updatedDisplaySettings = updateGridDisplaySettings(
      updatedColumn, fromJson(selectedFilter.displaySettings)
    );
    return this.saveUserFilter(selectedFilter, updatedDisplaySettings);
  }

  private saveUserFilter(selectedFilter: UserFilter, updatedDisplaySettings: GridDisplaySettings) {
    const updatedUserFilter = R.mergeRight(selectedFilter, {
      displaySettings: toJsonString(updatedDisplaySettings)
    });

    return this.userFilterDataService.updateUserFilter(updatedUserFilter).pipe(
      switchMap((response) => [
        new UpdateUserFilterSuccess(response),
        new InitDossiersInLocalStorage(),
        new SearchDossiersSuccess(DossierSearchType.FILTER)
      ]),
      catchError(error => of(new UpdateUserFilterFail(error)))
    );
  }

  constructor(
    private userService: UserService,
    private userDataService: UserDataService,
    private userFilterDataService: UserFilterDataService
  ) {
  }
}
